/******/ (() => { // webpackBootstrap
    var __webpack_exports__ = {};
    "use strict";

    Shopify.theme.jsContentColumns = {
        init: function init($section) {

            Shopify.theme.jsContentColumns = $.extend(this, Shopify.theme.getSectionData($section));

            this.$section = $section
            this.mainBlocks = []
            this.height = 0
            this.$left = $section.find('[data-left-column]')
            this.$right = $section.find('[data-right-column]')
            this.$connectedBlocks = $section.find('[data-connected-block]')
            console.log(this)
            if (this.$connectedBlocks.length && window.isScreenSizeLarge()) {
                this.fetchBlocks()
                this.initHanlders()
            }
            if (this.$connectedBlocks.length && !window.isScreenSizeLarge() && this.slider_on_mobile) {
                this.createSlider()
            }
        },
        createSlider: function () {
            let lOptions = {
                wrapAround: true,
                pageDots: false,
                prevNextButtons: false,
                cellAlign: 'center',
            }
            let rOptions = {
                wrapAround: true,
                pageDots: false,
                prevNextButtons: false,
                cellAlign: 'center',
                draggable: false,
                asNavFor: this.$left[0]
            }
            let leftSlider = this.$left.flickity(lOptions)
            let rightSlider = this.$right.flickity(rOptions)
        },
        fetchBlocks: function () {
            let $blocks = this.$connectedBlocks
            $blocks.each(function (index, block) {
                let id = $(block).data('connected-block')
                if (this.$section.find('#shopify-section-' + id).height() > this.height) {
                    this.height = this.$section.find('#shopify-section-' + id).find('img').height()
                }
                this.$section.find('#shopify-section-' + id).attr('data-connected-index', index)
            }.bind(this))
            this.$mainBlocks = this.$section.find('.image-with-text__block[data-connected-index]')
            this.hide()
            this.open(0)
        },
        open(index = 0) {

            this.hide()
            let $blocks = this.$connectedBlocks
            $blocks.eq(index).addClass('is-active')
            this.$mainBlocks.eq(index).show().find('img').css('height', this.height)
        },
        hide: function () {
            let $blocks = this.$connectedBlocks
            $blocks.removeClass('is-active')
            this.$mainBlocks.hide()
        },
        initHanlders: function () {
            let $blocks = this.$connectedBlocks
            $blocks.hover(function (e) {
                e.preventDefault()
                let index = $(e.target).data('connected-index')
                this.open(index)
            }.bind(this))
        },
        blockSelect: function blockSelect($section, blockId) {
            var $block = $('#shopify-section-' + blockId)
            var $slider = $section.find('.flickity-enabled[data-left-column]');
            if (!$slider.length && this.$connectedBlocks.length) {
                let $ele = $block.find('[data-connected-index]')
                if ($ele.length) {
                    let index = $ele.data('connected-index')
                    this.open(index)
                }
            }
            if ($slider.length && this.$connectedBlocks.length) {
                var index = $('#shopify-section-' + blockId).data('connected-index') || $('#shopify-section-' + blockId).find('[data-connected-index]').data('connected-index');
                $slider.flickity('select', index, true, true);
            }
        },
        unload: function unload($section) {

        }
    };


    /******/
})()
    ;